export interface AppHistoryState {
  canGoBack: boolean;
  canGoForward: boolean;
}

let historyStack = typeof window === "undefined" ? ["/"] : [window.location.pathname];
let historyIndex = 0;

function currentPath(): string {
  return typeof window === "undefined" ? "/" : window.location.pathname;
}

export function getAppHistoryState(): AppHistoryState {
  return {
    canGoBack: historyIndex > 0,
    canGoForward: historyIndex < historyStack.length - 1,
  };
}

export function initializeAppHistory(path = currentPath()): AppHistoryState {
  historyStack = [path];
  historyIndex = 0;
  return getAppHistoryState();
}

export function recordAppPush(path = currentPath()): AppHistoryState {
  historyStack = [...historyStack.slice(0, historyIndex + 1), path];
  historyIndex = historyStack.length - 1;
  return getAppHistoryState();
}

export function recordAppReplace(path = currentPath()): AppHistoryState {
  historyStack[historyIndex] = path;
  return getAppHistoryState();
}

export function recordAppPop(path = currentPath()): AppHistoryState {
  if (historyIndex > 0 && historyStack[historyIndex - 1] === path) {
    historyIndex -= 1;
  } else if (historyIndex < historyStack.length - 1 && historyStack[historyIndex + 1] === path) {
    historyIndex += 1;
  } else {
    historyStack = [...historyStack.slice(0, historyIndex + 1), path];
    historyIndex = historyStack.length - 1;
  }

  return getAppHistoryState();
}

export function recordAppBack(): AppHistoryState {
  historyIndex = Math.max(0, historyIndex - 1);
  return getAppHistoryState();
}

export function recordAppForward(): AppHistoryState {
  historyIndex = Math.min(historyStack.length - 1, historyIndex + 1);
  return getAppHistoryState();
}

export function getBackNavigationTarget(fallback = "/work-orders"): string | null {
  return getAppHistoryState().canGoBack ? null : fallback;
}

export function resetAppHistoryForTest(path = "/") {
  initializeAppHistory(path);
}
